import { ArrowRight } from 'lucide-react';
import { useSetRecoilState } from 'recoil';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

import { rightSidebarPanelState } from '@/state/project';

function focusAgentRow(agentId: string) {
    setTimeout(() => {
        const el = document.querySelector(`[data-agent-id="${agentId}"]`);
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.classList.add('ring-2', 'ring-foreground');
        setTimeout(() => el.classList.remove('ring-2', 'ring-foreground'), 2000);
    }, 300);
}

export function AgentDetailsPanelLink({ agentId }: { agentId: string }) {
    const setPanel = useSetRecoilState(rightSidebarPanelState);

    return (
        <DropdownMenuItem
            onSelect={() => {
                setPanel('agents');
                focusAgentRow(agentId);
            }}
            highlight={false}
            className="justify-end gap-1 mt-1 px-0 text-muted-foreground focus:text-foreground"
        >
            <span>Open full details</span>
            <ArrowRight />
        </DropdownMenuItem>
    );
}
